export default "__VITE_ASSET__GS6HPivJ__"